import { Trans, useTranslation } from 'react-i18next';

import { Button, Modal, Text } from '@hotjar/hotsauce';
import type { Organization } from '@hotjar/organization';

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  organization: Organization;
}

export const ConfirmConnectionModal = ({
  isOpen,
  isLoading,
  onSubmit,
  onCancel,
  organization,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const { name: organizationName } = organization;
  const title = t('common:settings.sso.confirm-connection-modal.title');

  return (
    <Modal
      isOpen={isOpen}
      contentLabel={title}
      onClose={onCancel}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      size="m"
    >
      <Modal.Header title={title} />

      <Modal.Body>
        <Text as="p">
          <Trans i18nKey="common:settings.sso.confirm-connection-modal.what-happens-next-for-them">
            <strong>What happens next for them</strong>
            <br />
            We’ll let everyone at {{ organizationName }} know they need to create a new Hotjar
            account using single sign-on credentials. They won’t be able to use their current email
            and passwords anymore.
          </Trans>
        </Text>

        <Text as="p">
          <Trans i18nKey="common:settings.sso.confirm-connection-modal.what-happens-next-for-you">
            <strong>What happens next for you</strong>
            <br />
            As an account owner, you can still use your email and password to access this
            organization if needed.
          </Trans>
        </Text>
      </Modal.Body>

      <Modal.Footer>
        <Button kind="ghost" isDisabled={isLoading} onClick={onCancel}>
          {t('common:settings.sso.confirm-connection-modal.cancel')}
        </Button>

        <Button kind="primary" isLoading={isLoading} onClick={onSubmit}>
          {t('common:settings.sso.confirm-connection-modal.submit')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
